<template>
  <div class="session">
    <div class="session__container">
      <div class="session__text">
        <h2>THÔNG BÁO</h2>
        Tài khoản hết phiên đăng nhập hoặc đã đăng xuất
      </div>
      <div>
        <img
          src="../../assets/images/user-illustarator-1.png"
          alt="session time out"
        />
      </div>
      <div class="session__button">
        <a :href="MethodService.purifyUrl(url)" class="session__button"
          >Bấm để đăng nhập lại hệ thống</a
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import MethodService from "@/service/MethodService";
import { getSystemType } from "@/utils/systemType";
const url = ref("");

onMounted(() => {
  const urlOld = localStorage.getItem("urlOld") || "/home";
  const urlPath = urlOld.split("?")[0];
  const typeLogin = localStorage.getItem("type_login") || "probe";
  const systemType = getSystemType();

  url.value =
    localStorage.getItem("urlPrimary") +
    "login" +
    "?urlOrigin=" +
    encodeURIComponent(location.origin) +
    "&url=" +
    encodeURIComponent(urlPath) +
    "&pid_probe=" +
    encodeURIComponent(localStorage.getItem("pid_probe") || "") +
    "&pid_summary=" +
    encodeURIComponent(localStorage.getItem("pid_summary") || "") +
    "&type_login=" +
    encodeURIComponent(typeLogin) +
    "&system_type=" +
    encodeURIComponent(systemType);
});
</script>

<style scoped lang="scss">
.session {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100vh;
  &__button {
    padding: 7px 15px;
    color: #fff;
    background-color: #409eff;
    width: fit-content;
    margin: auto;
    margin-top: 20px;
    border-radius: 5px;
  }
  &__text {
    margin: 20px 0;
    font-size: 20px;
    font-weight: 500;
  }
}

.session img {
  height: 400px;
  object-fit: contain;
}
</style>
